import { render } from "./KnowhowTip7.vue?vue&type=template&id=208cab55"
import script from "./KnowhowTip7.vue?vue&type=script&lang=js"
export * from "./KnowhowTip7.vue?vue&type=script&lang=js"

import "./KnowhowTip7.vue?vue&type=style&index=0&id=208cab55&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__